/* Mineral custom scripts */
(function () {
  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }

  /* 1. Hero video sound toggle */
  var ICON_OFF = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M16.5 12A4.5 4.5 0 0 0 14 7.97v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51A8.8 8.8 0 0 0 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06a8.99 8.99 0 0 0 3.69-1.81L19.73 21 21 19.73l-9-9L4.27 3zM12 4L9.91 6.09 12 8.18V4z"/></svg>';
  var ICON_ON  = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3A4.5 4.5 0 0 0 14 7.97v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z"/></svg>';
  function heroStyles() { if (document.getElementById('mnl-hero-sound-css')) return; var s = document.createElement('style'); s.id = 'mnl-hero-sound-css'; s.textContent = '.mnl-hero-sound{position:absolute;top:calc(var(--header-group-height,0px) + 16px);right:16px;z-index:20;width:44px;height:44px;border:0;border-radius:50%;cursor:pointer;display:grid;place-items:center;background:rgba(20,18,16,.55);color:#fff;-webkit-backdrop-filter:blur(8px);backdrop-filter:blur(8px);transition:background .2s ease,transform .2s ease;}.mnl-hero-sound:hover{background:rgba(20,18,16,.8);transform:scale(1.06);}.mnl-hero-sound svg{width:20px;height:20px;fill:#fff;}@media (max-width:749px){.mnl-hero-sound{width:40px;height:40px;top:calc(var(--header-group-height,0px) + 12px);right:12px;}}'; document.head.appendChild(s); }
  function setIcon(btn, video) { btn.innerHTML = video.muted ? ICON_OFF : ICON_ON; btn.setAttribute('aria-label', video.muted ? 'Turn sound on' : 'Turn sound off'); }
  function attachSound(section, video) {
    if (section.querySelector('.mnl-hero-sound')) return;
    heroStyles();
    if (window.getComputedStyle(section).position === 'static') section.style.position = 'relative';
    var btn = document.createElement('button'); btn.type = 'button'; btn.className = 'mnl-hero-sound'; setIcon(btn, video);
    btn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); video.muted = !video.muted; if (!video.muted) { video.volume = 1; var p = video.play(); if (p && p.catch) p.catch(function () {}); } setIcon(btn, video); });
    video.addEventListener('volumechange', function () { setIcon(btn, video); });
    section.appendChild(btn);
  }
  function scanHero() { document.querySelectorAll('.shopify-section[id*="hero"], .shopify-section[id*="video"]').forEach(function (section) { var video = section.querySelector('video'); if (video) attachSound(section, video); }); }

  /* 2. Description folds into a button */
  function foldDescription() {
    var scope = document.querySelector('.product-information');
    if (!scope || scope.querySelector('.mnl-desc')) return;
    var strongs = scope.querySelectorAll('strong'); var target = null;
    for (var i = 0; i < strongs.length; i++) { if (/^\s*Fit\s*:/i.test(strongs[i].textContent)) { target = strongs[i].closest('.rte, [class*="rte"], [class*="text-block"], [class*="text__"]') || strongs[i].parentElement.parentElement; break; } }
    if (!target) return null;
    var details = document.createElement('details'); details.className = 'mnl-desc';
    var summary = document.createElement('summary'); summary.textContent = 'Description';
    var body = document.createElement('div'); body.className = 'mnl-desc__body';
    while (target.firstChild) body.appendChild(target.firstChild);
    details.appendChild(summary); details.appendChild(body); target.appendChild(details);
    return details;
  }

  /* 3. Size chart popup, one chart per garment.
     snippets/size-chart-modal.liquid renders two hidden templates:
       #mnl-size-chart-hoodie and #mnl-size-chart-trousers
     Every .mnl-size-btn carries data-chart saying which one it wants. The
     click handler is DELEGATED on document so it covers both the button this
     script adds to the product page and the one "Complete the look" renders
     in Liquid — and those two can ask for different charts on the same page. */
  var sizeModal = null;
  function chartTemplate(kind) {
    return document.getElementById('mnl-size-chart-' + (kind === 'trousers' ? 'trousers' : 'hoodie'));
  }
  function buildSizeModal() {
    if (sizeModal) return sizeModal;
    sizeModal = document.createElement('div');
    sizeModal.className = 'mnl-size-modal';
    sizeModal.innerHTML = '<div class="mnl-size-modal__box"><button type="button" class="mnl-size-modal__close" aria-label="Close">&#215;</button><div class="mnl-size-modal__content"></div></div>';
    document.body.appendChild(sizeModal);
    sizeModal.querySelector('.mnl-size-modal__close').addEventListener('click', closeSizeModal);
    sizeModal.addEventListener('click', function (e) { if (e.target === sizeModal) closeSizeModal(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && sizeModal.classList.contains('is-open')) closeSizeModal(); });
    return sizeModal;
  }
  function openSizeModal(kind) {
    var template = chartTemplate(kind);
    if (!template) return;
    buildSizeModal();
    sizeModal.querySelector('.mnl-size-modal__content').innerHTML = template.innerHTML;
    sizeModal.classList.add('is-open');
    document.body.classList.add('mnl-size-open');
  }
  function closeSizeModal() { if (!sizeModal) return; sizeModal.classList.remove('is-open'); document.body.classList.remove('mnl-size-open'); }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('.mnl-size-btn') : null;
    if (!btn) return;
    e.preventDefault();
    openSizeModal(btn.getAttribute('data-chart') || 'hoodie');
  });

  function productChartKind() {
    var titleEl = document.querySelector('.product-information h1');
    var title = titleEl ? titleEl.textContent : '';
    return /trouser/i.test(title) ? 'trousers' : 'hoodie';
  }

  function addSizeChartButton(afterEl) {
    var scope = document.querySelector('.product-information');
    if (!scope || scope.querySelector('.mnl-size-btn')) return null;
    var kind = productChartKind();
    if (!chartTemplate(kind)) return null;

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'mnl-size-btn';
    btn.setAttribute('data-chart', kind);
    btn.textContent = 'Size Chart';

    if (afterEl && afterEl.parentNode) afterEl.insertAdjacentElement('afterend', btn);
    else scope.appendChild(btn);
    return btn;
  }

  /* 3b. Shipping & Returns accordion, directly under Size Chart. */
  function addShippingReturns(afterEl) {
    var scope = document.querySelector('.product-information');
    var template = document.getElementById('mnl-shipping-template');
    if (!scope || !template || scope.querySelector('.mnl-ship')) return null;

    var details = document.createElement('details');
    details.className = 'mnl-ship';

    var summary = document.createElement('summary');
    summary.textContent = 'Shipping & Returns';

    var body = document.createElement('div');
    body.className = 'mnl-desc__body';
    body.innerHTML = template.innerHTML;

    details.appendChild(summary);
    details.appendChild(body);

    if (afterEl && afterEl.parentNode) afterEl.insertAdjacentElement('afterend', details);
    else scope.appendChild(details);
    return details;
  }

  /* 4. Lightbox with a thumbnail rail, navigable by click, arrow keys, or scroll */
  function bigSrc(img) { var src = img.currentSrc || img.src || ''; return src.replace(/([?&])width=\d+/, '$1width=2400').replace(/_\d+x\d*\./, '.'); }
  var lb = null, lbIndex = 0, lbImgs = [];
  var wheelAccum = 0, wheelLastT = 0;

  function buildLightbox() {
    if (lb) return lb;
    lb = document.createElement('div'); lb.className = 'mnl-lb'; lb.setAttribute('role', 'dialog'); lb.setAttribute('aria-modal', 'true');
    lb.innerHTML = '<div class="mnl-lb__stage"><img alt=""><button type="button" class="mnl-lb__prev" aria-label="Previous">&#8249;</button><button type="button" class="mnl-lb__next" aria-label="Next">&#8250;</button><button type="button" class="mnl-lb__close" aria-label="Close">&#215;</button><div class="mnl-lb__count"></div></div><div class="mnl-lb__thumbs"></div>';
    document.body.appendChild(lb);
    lb.querySelector('.mnl-lb__close').addEventListener('click', closeLightbox);
    lb.querySelector('.mnl-lb__prev').addEventListener('click', function () { showLightbox(lbIndex - 1); });
    lb.querySelector('.mnl-lb__next').addEventListener('click', function () { showLightbox(lbIndex + 1); });
    lb.querySelector('.mnl-lb__stage').addEventListener('click', function (e) { if (e.target === e.currentTarget) closeLightbox(); });
    document.addEventListener('keydown', function (e) { if (!lb.classList.contains('is-open')) return; if (e.key === 'Escape') closeLightbox(); if (e.key === 'ArrowLeft') showLightbox(lbIndex - 1); if (e.key === 'ArrowRight') showLightbox(lbIndex + 1); });

    var stage = lb.querySelector('.mnl-lb__stage');
    stage.addEventListener('wheel', function (e) {
      e.preventDefault();
      var now = Date.now();
      if (now - wheelLastT > 500) wheelAccum = 0;
      wheelLastT = now;
      var delta = Math.abs(e.deltaY) > Math.abs(e.deltaX) ? e.deltaY : e.deltaX;
      wheelAccum += delta;
      var THRESHOLD = 60;
      if (wheelAccum > THRESHOLD) { wheelAccum = 0; showLightbox(lbIndex + 1); }
      else if (wheelAccum < -THRESHOLD) { wheelAccum = 0; showLightbox(lbIndex - 1); }
    }, { passive: false });

    var touchStartY = null;
    stage.addEventListener('touchstart', function (e) { if (e.touches.length === 1) touchStartY = e.touches[0].clientY; }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (touchStartY === null) return;
      var endY = (e.changedTouches && e.changedTouches[0]) ? e.changedTouches[0].clientY : touchStartY;
      var dy = touchStartY - endY;
      touchStartY = null;
      if (Math.abs(dy) > 40) { if (dy > 0) showLightbox(lbIndex + 1); else showLightbox(lbIndex - 1); }
    }, { passive: true });

    return lb;
  }
  function showLightbox(i) {
    if (!lbImgs.length) return;
    lbIndex = (i + lbImgs.length) % lbImgs.length;
    var stageImg = lb.querySelector('.mnl-lb__stage img'); stageImg.src = lbImgs[lbIndex].big; stageImg.alt = lbImgs[lbIndex].alt;
    lb.querySelector('.mnl-lb__count').textContent = (lbIndex + 1) + ' / ' + lbImgs.length;
    lb.querySelectorAll('.mnl-lb__thumb').forEach(function (t, n) { t.classList.toggle('is-active', n === lbIndex); if (n === lbIndex) t.scrollIntoView({ block: 'nearest', inline: 'nearest' }); });
  }
  function openLightbox(startIndex) {
    buildLightbox();
    var rail = lb.querySelector('.mnl-lb__thumbs'); rail.innerHTML = '';
    lbImgs.forEach(function (it, n) { var b = document.createElement('button'); b.type = 'button'; b.className = 'mnl-lb__thumb'; b.innerHTML = '<img src="' + it.thumb + '" alt="">'; b.addEventListener('click', function () { showLightbox(n); }); rail.appendChild(b); });
    document.body.classList.add('mnl-lb-open'); lb.classList.add('is-open'); wheelAccum = 0; showLightbox(startIndex || 0);
  }
  function closeLightbox() { if (!lb) return; lb.classList.remove('is-open'); document.body.classList.remove('mnl-lb-open'); }

  var CONTROLS = 'slideshow-controls, [class*="slideshow-control"], [class*="slideshow__control"], [class*="slideshow-arrow"], [class*="slideshow__arrow"], [class*="thumbnail"], deferred-media, video';
  function collect(media, clicked) {
    var all = Array.prototype.slice.call(media.querySelectorAll('.product-media img, .product-media__image'));
    var seen = {}; lbImgs = []; var start = 0;
    all.forEach(function (el) {
      var key = (el.currentSrc || el.src || '').split('?')[0];
      if (!key || seen[key]) return; seen[key] = true;
      if (el === clicked) start = lbImgs.length;
      lbImgs.push({ big: bigSrc(el), thumb: el.currentSrc || el.src, alt: el.alt || '' });
    });
    return start;
  }
  function intercept(e) {
    var media = e.currentTarget;
    if (e.target.closest(CONTROLS)) return;
    var slide = e.target.closest('.product-media');
    if (!slide) return;
    var img = slide.querySelector('img');
    if (!img) return;
    e.preventDefault(); e.stopPropagation();
    if (e.type !== 'click') return;
    var start = collect(media, img);
    if (lbImgs.length) openLightbox(start);
  }
  function wireLightbox() {
    var media = document.querySelector('.product-information [class*="mnl-media-"]');
    if (!media || media.dataset.mnlLb) return;
    media.dataset.mnlLb = '1';
    ['pointerdown', 'mousedown', 'click'].forEach(function (evt) { media.addEventListener(evt, intercept, true); });
  }

  /* 5. Sticky photo. See the long note kept with this function: Horizon's
     .page-wrapper is the scroller above 990px, the details column height is
     not knowable from CSS, and images settle late — hence measured pixels,
     three scroll listeners and a ResizeObserver. */
  var stickyMediaEls = null;
  function stickyMediaSetup() {
    if (window.matchMedia('(max-width: 749px)').matches) return null;
    var section = document.querySelector('.product-information');
    var mediaContainer = section && section.querySelector('.product-information__media');
    var photo = mediaContainer && mediaContainer.querySelector('[class*="mnl-media-"]');
    if (!section || !mediaContainer || !photo) return null;
    return { section: section, mediaContainer: mediaContainer, photo: photo };
  }
  function stickyMediaUpdate() {
    if (!stickyMediaEls) return;
    var section = stickyMediaEls.section;
    var mediaContainer = stickyMediaEls.mediaContainer;
    var photo = stickyMediaEls.photo;
    var headerH = parseFloat(getComputedStyle(document.body).getPropertyValue('--header-height')) || 0;
    var sectionRect = section.getBoundingClientRect();
    var mediaTop = mediaContainer.getBoundingClientRect().top;
    var photoHeight = photo.offsetHeight;
    var maxTranslate = Math.max(sectionRect.height - photoHeight, 0);
    var wanted = headerH - mediaTop;
    var translate = Math.min(Math.max(wanted, 0), maxTranslate);
    photo.style.transform = 'translateY(' + translate + 'px)';
  }
  function stickyMediaTeardown() {
    if (!stickyMediaEls) return;
    stickyMediaEls.photo.style.transform = '';
  }
  var stickyMediaListenersBound = false;
  var stickyMediaResizeObserver = null;
  function bindStickyMediaListeners() {
    if (stickyMediaListenersBound) return;
    stickyMediaListenersBound = true;
    window.addEventListener('scroll', stickyMediaUpdate, { passive: true });
    var wrapper = document.querySelector('.page-wrapper');
    if (wrapper) wrapper.addEventListener('scroll', stickyMediaUpdate, { passive: true });
    var raf = false;
    var rafTick = function () { raf = false; stickyMediaUpdate(); };
    document.addEventListener('scroll', function () { if (!raf) { raf = true; requestAnimationFrame(rafTick); } }, { passive: true, capture: true });
  }
  function bindResizeObserver(found) {
    if (stickyMediaResizeObserver) stickyMediaResizeObserver.disconnect();
    if (typeof ResizeObserver === 'undefined') return;
    stickyMediaResizeObserver = new ResizeObserver(function () { stickyMediaUpdate(); });
    stickyMediaResizeObserver.observe(found.section);
    stickyMediaResizeObserver.observe(found.photo);
  }
  function initStickyMedia() {
    var found = stickyMediaSetup();
    if (found) {
      bindStickyMediaListeners();
      if (stickyMediaEls === null || stickyMediaEls.photo !== found.photo) bindResizeObserver(found);
      stickyMediaEls = found;
      stickyMediaUpdate();
      requestAnimationFrame(stickyMediaUpdate);
      setTimeout(stickyMediaUpdate, 300);
      setTimeout(stickyMediaUpdate, 1200);
    } else if (stickyMediaEls) {
      stickyMediaTeardown();
      stickyMediaEls = null;
      if (stickyMediaResizeObserver) { stickyMediaResizeObserver.disconnect(); stickyMediaResizeObserver = null; }
    }
  }

  /* 6. "Complete the look" photo matches the main product photo's height. */
  var ctlResizeObserver = null;
  function matchCtlHeight() {
    var ctlMedia = document.querySelector('.ctl-media');
    if (!ctlMedia) return;

    if (window.matchMedia('(max-width: 749px)').matches) {
      ctlMedia.style.minHeight = '';
      return;
    }

    var productMedia = document.querySelector('.product-information .product-information__media');
    if (!productMedia) return;

    var h = productMedia.getBoundingClientRect().height;
    if (!h) return;
    ctlMedia.style.minHeight = Math.round(h) + 'px';

    if (!ctlResizeObserver && typeof ResizeObserver !== 'undefined') {
      ctlResizeObserver = new ResizeObserver(function () { matchCtlHeight(); });
      ctlResizeObserver.observe(productMedia);
    }
  }

  /* 7. "Complete the look" add to cart, without leaving the page.

     ROOT CAUSE of the old behaviour: the main product page's Add to cart is
     wrapped in Horizon's <product-form-component>, whose handleSubmit() calls
     event.preventDefault() and posts to the cart over fetch. The CTL section
     renders a plain Liquid {% form 'product' %} with no such wrapper, so the
     browser did what a plain form does — a full POST to /cart/add followed by
     a redirect to the cart page.

     Fix: submit it over fetch instead. The cart page is never opened and the
     cart drawer is deliberately NOT opened either; only the header count
     updates, via <cart-icon>'s own public renderCartBubble() method, so the
     bubble animates exactly as it does for a normal add. */
  function ctlButtonFeedback(button, text) {
    if (!button) return;
    if (!button.dataset.mnlLabel) button.dataset.mnlLabel = button.textContent;
    button.textContent = text;
    clearTimeout(button._mnlTimer);
    button._mnlTimer = setTimeout(function () {
      button.textContent = button.dataset.mnlLabel;
    }, 2000);
  }

  function refreshCartBubble() {
    return fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root + 'cart.js'
      : '/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var icon = document.querySelector('cart-icon');
        if (icon && typeof icon.renderCartBubble === 'function') {
          icon.renderCartBubble(cart.item_count);
        }
        return cart;
      })
      .catch(function () { /* the item is already in the cart; the bubble catches up on the next page load */ });
  }

  function wireCtlForm() {
    var form = document.querySelector('.ctl-info form');
    if (!form || form.dataset.mnlAjax) return;
    form.dataset.mnlAjax = '1';

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var button = form.querySelector('.ctl-cta');
      if (button && button.disabled) return;

      var body = new FormData(form);
      if (button) { button.disabled = true; ctlButtonFeedback(button, 'ADDING...'); }

      var addUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root)
        ? window.Shopify.routes.root + 'cart/add.js'
        : '/cart/add.js';

      fetch(addUrl, { method: 'POST', body: body, credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
        .then(function (res) {
          if (!res.ok) {
            ctlButtonFeedback(button, (res.data && res.data.description) ? 'UNAVAILABLE' : 'TRY AGAIN');
            return;
          }
          ctlButtonFeedback(button, 'ADDED');
          return refreshCartBubble();
        })
        .catch(function () { ctlButtonFeedback(button, 'TRY AGAIN'); })
        .finally(function () { if (button) button.disabled = false; });
    });
  }

  function runAll() {
    scanHero();
    var descEl = foldDescription() || document.querySelector('.product-information .mnl-desc');
    wireLightbox();
    var sizeBtn = addSizeChartButton(descEl) || document.querySelector('.product-information .mnl-size-btn');
    addShippingReturns(sizeBtn || descEl);
    initStickyMedia();
    matchCtlHeight();
    wireCtlForm();
  }

  ready(function () {
    runAll();
    var tries = 0;
    var t = setInterval(function () { runAll(); if (++tries > 20) clearInterval(t); }, 500);
    document.addEventListener('shopify:section:load', runAll);
    window.addEventListener('resize', function () {
      if (stickyMediaEls) stickyMediaUpdate(); else initStickyMedia();
      matchCtlHeight();
    });
    window.addEventListener('load', function () {
      if (stickyMediaEls) stickyMediaUpdate();
      matchCtlHeight();
    });
  });
})();
